<template>
    <nav
        :aria-label="ariaLabel"
        :class="[$attrs.class, isExpanded ? `block! ${expandedClass}` : collapsedClass]"
        class="group fixed top-0 bottom-5 left-0 z-500 hidden border-slate-100 bg-white transition-all duration-200 ease-out md:block md:shrink-0 print:hidden!"
        @mouseenter="setExpanded(true)"
        @mouseleave="setExpanded(false)"
    >
        <div v-if="backgroundClass" :class="backgroundClass" class="absolute inset-0" />

        <div
            class="absolute top-20 right-0 flex h-5 w-5 translate-x-1/2 items-center justify-center rounded-full border border-slate-200 bg-white text-slate-400 shadow-xs"
        >
            <ChevronRightIcon :class="{ 'rotate-180': isExpanded }" class="h-3 w-3" />
        </div>

        <div class="relative flex h-full w-full flex-col gap-3 pb-3">
            <LeftNavLogo :is-expanded="isExpanded" />
            <slot :is-expanded="isExpanded" />
        </div>
    </nav>

    <slot name="after" :is-expanded="isExpanded" :set-expanded="setExpanded" />
</template>

<script setup>
import { ChevronRightIcon } from 'lucide-vue-next'

defineProps({
    ariaLabel: {
        type: String,
        default: 'Sidebar',
    },
    expandedClass: {
        type: String,
        default: 'w-[325px] border-r shadow-xl',
    },
    collapsedClass: {
        type: String,
        default: 'w-24 border-r',
    },
    backgroundClass: {
        type: String,
        default: '',
    },
})

const isExpanded = ref(false)

function setExpanded(newState) {
    isExpanded.value = newState
}
</script>
